import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

Vue.prototype.$t_ = Vue.prototype.$t;
Vue.prototype.$t = function (key) {
  var values = [], len = arguments.length - 1;
  while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

  const localeKey = key + '.' + _domainCntryCode;

  var i18n = this.$i18n;
  var message = i18n._t.apply(i18n, [ localeKey, i18n.locale, i18n._getMessages(), this ].concat( values ));

  if(localeKey === message) {
    message = i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ));
    if(message === key) {
      if(key.indexOf("gwa.alt") === 0) {
        return "";
      }
    }
  }
  return message;
};


export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'kor',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'engu',
  messages: loadLocaleMessages()
})
